import { useDelete, UseDeleteParams } from '../../../../api';
import { useCallback } from 'react';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { User } from '../../types/User';

interface DeleteUserResponse {
    userGuid: User['guid'];
}

interface DeleteUserErrorResponse {
    error: string;
}

type UseDeleteUserParams = UseDeleteParams<DeleteUserResponse, DeleteUserErrorResponse>;

export const useDeleteUser = (params: UseDeleteUserParams) => {
    const { deleteMethod, loading, error } = useDelete(params);

    const deleteUser = useCallback(
        (userGuid: User['guid']) => deleteMethod(`${USER_MANAGEMENT_BASE_URL}/${userGuid}`),
        [deleteMethod]
    );

    return {
        loading,
        error,
        deleteUser
    };
};
